var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEndTurn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -0.5 26 26",
    shapeRendering: "crispEdges",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M6 2h2M6 3h2M4 4h2m2 0h2M4 5h2m2 0h2M2 6h2m2 0h2M2 7h2m2 0h2M2 8h2m2 0h2M2 9h2m2 0h2m-8 1h2m4 0h2m-8 1h2m4 0h2m-8 1h2m4 0h2m-8 1h2m4 0h2m-8 1h2m6 0h2m8 0h2M0 15h2m6 0h2m8 0h2M2 16h2m6 0h8m2 0h2M2 17h2m6 0h8m2 0h2M2 18h2m14 0h2M2 19h2m14 0h2M4 20h4m6 0h4M4 21h4m6 0h4M8 22h6m-6 1h6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#f2fffd",
    d: "M6 4h2M6 5h2M4 6h2M4 7h2M4 8h2M4 9h2m-4 1h4m-4 1h4m-4 1h2m-2 1h2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#daf1f2",
    d: "M4 12h2m-2 1h2m-4 1h6m-6 1h6m-4 1h4m-4 1h4m-4 1h2m-2 1h2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#c6eaef",
    d: "M8 16h2m8 0h2M8 17h2m8 0h2M6 18h8m-8 1h8m-6 1h2m-2 1h2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#99d1d8",
    d: "M14 18h4m-4 1h4m-8 1h4m-4 1h4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEndTurn);
export default __webpack_public_path__ + "static/media/end-turn.a44ebc1284345070a714522a25513e92.svg";
export { ForwardRef as ReactComponent };